import { getChangedPath } from "./getChangedPath";

export const setModelProperty = (property: string, value: any, target: any) => {
  property = getChangedPath(property);

  if (property.indexOf(".") === -1) {
    target[property] = value;
  } else {
    const parts = property.split(".");
    let current = target;
    const cProp = parts[parts.length - 1];
    const isLastArray = !isNaN(parseInt(cProp, 10));
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      if (!current[part]) {
        const isArray = !isNaN(parseInt(parts[i + 1], 10));
        current[part] = isArray ? [] : {};
      }

      current = current[part];
    }

    if (isLastArray) {
      if (value !== undefined) {
        current.push(value);
      }
    } else {
      current[cProp] = value;
    }
  }
};
